import React, { Component } from 'react'
import config from '../../../config'
import { Card, Jumbotron, Col, Form, Button, Table } from 'react-bootstrap';
import errores from '../../../middleware/errordb';
import funciones from '../../../middleware/funciones';
import Mensajes from '../../subcomponent/mensajes'

import ModalConfirm from '../../subcomponent/modalConfirm';

export class grupoInventario extends Component {
    constructor(props) {
        super(props);

        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            evento: 1,
            fecha: todayFormat,
            codigo: "1",
            estado: "1",
            descripcion: "",
            mostrarMensaje: false,
            empresa: currentCompany,
            tipo: currentUserType,
            grupoInventario: [],
            tipoInventario: [],
            tipoInv: "",
            mensaje: "",
            textButton: "Crear Grupo"
        }
    }

    componentDidMount() {
        this.infoGrupo();
    }

    infoGrupo = () => {
        const empresaEdicion = this.state.empresa;
        if (empresaEdicion) {
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/groupinventary/', datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        const grupoInventario = datos[0];
                        const codigo = datos[1][0]["LAST_COD"];
                        const tipoInventario = datos[2];
                        this.setState({
                            grupoInventario,
                            codigo,
                            controlCodigo: codigo,
                            tipoInventario
                        })
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: "Sin tipos creados" })
                    }
                });
        }
    }

    createGroup = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        event.preventDefault();
        const { evento } = this.state
        const { codigo } = this.state
        const { descripcion } = this.state
        const { estado } = this.state
        const { empresa } = this.state
        const { tipoInv } = this.state

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: empresa,
                CODIGO_GRUPO_INV: codigo,
                DESCRIPCION_GRUPO_INV: descripcion,
                ESTADO_GRUPO_INV: estado,
                ID_TIPO_INVENTARIO: tipoInv
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }
        let url = "";
        if (evento) {
            url = "/groupinventary/create/";
        } else {
            url = "/groupinventary/modify/"
        }
        fetch(config.servBackEnd + url, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.infoGrupo();
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", descripcion: "", estado: "1", tipoInv: "", evento: 1, textButton: "Crear Grupo" });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Error en Tipo de inventario: " + errores[data.code] + " " + data.message })
                }
            });
    }

    edittype = (selected) => {
        this.setState({
            codigo: selected.CODIGO_GRUPO_INV,
            descripcion: selected.DESCRIPCION_GRUPO_INV,
            estado: selected.ESTADO_GRUPO_INV,
            tipoInv: selected.ID_TIPO_INVENTARIO,
            evento: 0,
            textButton: "Modificar Grupo"
        })
    }
    cleanForm = () => {
        const { controlCodigo } = this.state;
        this.setState({
            codigo: controlCodigo,
            descripcion: "",
            tipoInv: "",
            estado: "1",
            evento: 1,
            textButton: "Crear Grupo"
        })
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const { grupoInventario } = this.state;
        const { tipoInventario } = this.state;
        const edittype = this.edittype;
        const mensajeConfirm = (this.state.evento) ? '¿Está seguro que desea crear el grupo de inventario?' : '¿Está seguro que desea modificar el grupo de inventario?';
        return (
            <div>

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>Grupos</h2>
                </Jumbotron>
                <div>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.createGroup}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Codigo</Form.Label>
                                        <Form.Control type="text" value={this.state.codigo} required readOnly />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" onChange={e => this.setState({ tipoInv: e.target.value })} value={this.state.tipoInv} required >
                                            <option value="">--Seleccione--</option>
                                            {tipoInventario.map((element, i) => {
                                                return (<option key={i} value={element.ID_TIPO_INVENTARIO}>{element.DESCRIPCION_TIPO_INV}</option>)
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Descripcion</Form.Label>
                                        <Form.Control type="text" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase() })} value={this.state.descripcion} required />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" onChange={e => this.setState({ estado: e.target.value })} value={this.state.estado} required >
                                            <option value="1">ACTIVO</option>
                                            <option value="0">INACTIVO</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                {!this.state.evento && <Button className="m-3" variant="primary" onClick={this.cleanForm}>Limpiar</Button>}
                                <Button className="m-3" variant="primary" type="submit">{this.state.textButton}</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <div className="contenedor">
                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>Empresa</th>
                                <th>Tipo Inventario</th>
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Estado</th>
                                <th colSpan="2">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {grupoInventario.map(function (currentData, index) {
                                return <tr key={index + "d0"}>
                                    <td>{currentData.ID_EMPRESA}</td>
                                    <td>{currentData.DESCRIPCION_TIPO_INV}</td>
                                    <td>{currentData.CODIGO_GRUPO_INV}</td>
                                    <td>{currentData.DESCRIPCION_GRUPO_INV}</td>
                                    <td>{funciones.textEstadoGeneral(currentData.ESTADO_GRUPO_INV)}</td>
                                    <td><Button onClick={() => edittype(currentData)} variant="outline-primary">Editar</Button></td>
                                </tr>;
                            })}
                        </tbody>
                    </Table>
                </div>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        )
    }
}

export default grupoInventario



// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/grupoInventario.jsx